function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  d: "M277.333,234.667c0-7.792-4.409-14.329-10.667-18.053v-35.28c0-5.896-4.771-10.667-10.667-10.667 s-10.667,4.771-10.667,10.667v35.28c-6.258,3.724-10.667,10.262-10.667,18.053c0,11.76,9.573,21.333,21.333,21.333 S277.333,246.427,277.333,234.667z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  d: "M437.333,0c-41.865,0-74.667,37.479-74.667,85.333c0,34.341,25.902,95.176,64,105.121v204.212c0,52.938-43.063,96-96,96 c-50.943,0-92.335-39.995-95.411-90.176c33.447-4.255,63.411-12.215,63.411-27.158v-41.042c37.604-16.507,64-53.997,64-97.625 c0-43.628-26.396-81.119-64-97.625V74.667c0-30.458-124.396-32-149.333-32S0,44.208,0,74.667v298.667 c0,30.458,124.396,32,149.333,32c10.102,0,36.546-0.289,64.408-2.615C217.91,463.66,268.686,512,330.667,512 C395.365,512,448,459.365,448,394.667V190.454c38.098-9.945,64-70.78,64-105.121C512,37.479,479.198,0,437.333,0z M32.781,74.667 C54.427,69.375,98.667,64,149.333,64C200,64,244.24,69.375,265.885,74.667C244.24,79.958,200,85.333,149.333,85.333 C98.667,85.333,54.427,79.958,32.781,74.667z M170.667,234.667c0-47.052,38.281-85.333,85.333-85.333 s85.333,38.281,85.333,85.333C341.333,281.719,303.052,320,256,320S170.667,281.719,170.667,234.667z"
}));

const SvgIconBloodPressure = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBloodPressure, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_BloodPressure.20dc658a.svg";
export { ForwardRef as ReactComponent };